import { useApiQuery } from 'theSource/utils';
import { BenefitsPageResponseDto } from './types';
import { GET_BENEFITS_QUERY_KEY } from './utils';

export interface UseBenefitsQueryProps {
  enabled: boolean;
}

export const useBenefitsQuery = ({ enabled }: UseBenefitsQueryProps) => {
  return useApiQuery<BenefitsPageResponseDto, unknown>({
    queryKey: GET_BENEFITS_QUERY_KEY,
    endpoint:
      '/coverages/?enrollment_type_lookup_code=&life_event_completed=false',
    enabled,
  });
};
